import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

/** Quick hack for wrapping the headline for homepage mvp
 * Can't use our injected them breakpoints here,
 * since this rendered under the DLS theme provider */
const HeroHeading = styled.div`
  @media only screen and (min-width: ${breakpoints.sm}px) {
    max-width: 400px;
  }
  @media only screen and (min-width: ${breakpoints.lg}px) {
    max-width: none;
  }
`;

export const LANDING_CTA_LINK = "/subscribe";

const landingConfig = {
  hero: {
    bgColor: "mintTint3" as const,
    ctaLabel: "Get Started",
    disclaimer: "Always free shipping. Unlimited returns.",
    heading: (
      <HeroHeading>
        Raise a <br />
        <em>lifelong reader</em>
      </HeroHeading>
    ),
    imageProps: {
      alt: "Kids books in a literati box",
      height: 920,
      src: "//images.ctfassets.net/vqtz4cq2w5ts/7Le9x0UXHvpMHnaoq70KD2/9e45dfc6436d06ba39a2bef849f1b4a0/Homepage_Kids_Focus_Hero_Desktop.png",
      targetHeight: 460,
      width: 1304,
    },
    subtext: (
      <>
        Professionally curated books + parent tips that <br />
        build early literacy—one joyful box at a time.
      </>
    ),
  },
  readingStage: {
    bgColor: "papierBlanc" as const,
    primaryHeading: (
      <>
        Kids books for&nbsp;
        <br />
        every stage of reading,&nbsp;
        <br />
        picked by experts.
      </>
    ),
    subtext:
      "Our literacy experts tailor each book box to your reader's pace and interests.",
    items: [
      {
        imageProps: {
          alt: "Book with a gem on the cover",
          height: 120,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/12SjCFdPlymcf4KbjPAiwn/c5e67c0e7d62d38a48404210baee15bc/Homepage_Kids_Focus_Reading_Stage_Icon_Gems.svg",
          width: 125,
        },
        primaryCopy: (
          <>
            Discover hidden gems&nbsp;
            <br />
            that fit their interests
          </>
        ),
      },
      {
        imageProps: {
          alt: "Open book with a magnifying glass looking at the page",
          height: 120,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/6Lz04ncBU2De7gNkJGQiQ/f87e1789c73479884c232f898cc09dcf/Homepage_Kids_Focus_Reading_Stage_Icon_Openbook.svg",
          width: 141,
        },
        primaryCopy: (
          <>
            Improve vocabulary,&nbsp;
            <br />
            confidence, and speed
          </>
        ),
      },
      {
        imageProps: {
          alt: "Stack of books with a flag on top",
          height: 120,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/4P4aYtSY7l4w9u59Oin3JV/6c093607b984c308ce62d47f4e703c08/Homepage_Kids_Focus_Reading_Stage_Icon_Bookstack.svg",
          width: 98,
        },
        primaryCopy: (
          <>
            Advance through reading&nbsp;
            <br />
            levels with personalized picks
          </>
        ),
      },
    ],
  },
  subscriberStats: {
    gradient: {
      topColor: "papierBlanc" as const,
      bottomColor: "frenchBlueTint4" as const,
    },
    eyebrow: "subscriber stats",
    stats: [
      {
        description: (
          <>
            average increase in daily reading&nbsp;
            <br />
            time reported by Literati parents.
          </>
        ),
        value: "39 mins",
      },
      {
        description: (
          <>
            of members say Literati increased&nbsp;
            <br />
            their kid&apos;s interest in reading.
          </>
        ),
        value: "75%",
      },
      {
        description: (
          <>
            of members say their kids found a&nbsp;
            <br />
            favorite book with Literati.
          </>
        ),
        value: "81%",
      },
    ],
  },
  preferencesClaim: {
    bgColor: "frenchBlueTint4" as const,
    primaryHeading: "Tell us what they like and we’ll send books they’ll love.",
    subtext:
      "Book curation starts with their preferences, and improves as you and your reader provide feedback.",
    imageProps: {
      alt: "Mutiple books arranged in a rainbow based on cover color",
      height: 243,
      src: "//images.ctfassets.net/vqtz4cq2w5ts/5RVvN7eBftUVrVQYRJmrKW/736fcacca8f26ed35e09689aa401c7af/Homepage_Kids_Focus_Standing_Rainbow_Books.png",
      width: 1140,
    },
  },
  howItWorks: {
    gradient: {
      topColor: "frenchBlueTint4" as const,
      bottomColor: "papierBlanc" as const,
    },
    eyebrow: "how it works",
    heading: (
      <>
        Five books, delivered&nbsp;
        <br />
        to your door. Only&nbsp;
        <br />
        buy your favorites.
      </>
    ),
    items: [
      {
        imageProps: {
          alt: "Illustration of 3 kids with books in front of them",
          height: 460,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/4dJw6OEqPmnDCIQMGEzJeQ/599a1a6f491c23572df12d26068dd3cb/Homepage_Kids_Focus_HowItWorks_3kids.png",
          targetHeight: 230,
          width: 460,
        },
        primaryCopy: "Five Personalized Picks",
        subtext: (
          <>
            Tell us about your reader & we&apos;ll&nbsp;
            <br />
            send curated book boxes&nbsp;
            <br />
            just for them.
          </>
        ),
      },
      {
        imageProps: {
          alt: "Books exploding out of a literati box",
          height: 460,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/6XDKTsS3XsG1QwsvADByuk/7251b2e032153d3011951696b3d9bcb1/Homepage_Kids_Focus_HowItWorks_ExplodingBox.png",
          targetHeight: 230,
          width: 460,
        },
        primaryCopy: "Better with Every Box",
        subtext: (
          <>
            Curation improves and adapts to fit&nbsp;
            <br />
            your reader as they progress.
          </>
        ),
      },
      {
        imageProps: {
          alt: "Child removing literati box from mailbox with calendar in the background",
          height: 460,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/6WGdNRQ3T1sFpJcDVfBjP2/e9870e4aa3f876ee402c3c853f7d516c/Homepage_Kids_Focus_HowItWorks_MailboxCalendar.png",
          targetHeight: 230,
          width: 460,
        },
        primaryCopy: "Free Unlimited Returns",
        subtext: (
          <>
            Keep the stories they love. We&apos;ll take&nbsp;
            <br />
            back anything they don&apos;t.
          </>
        ),
      },
    ],
  },
  personalizedSkills: {
    bgColor: "papierBlanc" as const,
    primaryHeading: (
      <>
        Personalized picks to push&nbsp;
        <br />
        their skills at every stage.
      </>
    ),
    subtext:
      "Our reading levels follow skill-based benchmarks, so readers can advance at the right pace for them. ",
    items: [
      {
        ctaLabel: "Get Babies & Toddlers Box",
        infoCTAProps: {
          borderColor: "periwinkleWhimsical" as const,
          description: {
            primary: "Build a home library full of sensory excitement",
            subtext:
              "Little ones will see and feel their way through interactive board books and vibrant picture books, perfect for reading aloud.",
          },
          primaryHeading: "Babies & Toddlers",
          ribbonProps: {
            bgColor: "periwinkleWhimsical" as const,
            label: "Ages 0 - 4",
            labelColor: "white" as const,
          },
        },
        imageProps: {
          alt: "Stack of books for babies and toddlers",
          height: 1000,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/46uJJDowdSwY7DPLm80siz/47c2750cdbda518c0b2a26573a94afe2/Homepage_Kids_Focus_Category_Babies_Toddlers.png",
          targetHeight: 500,
          width: 1100,
        },
      },
      {
        ctaLabel: "Get Preschool – 2nd Grade Box",
        infoCTAProps: {
          borderColor: "frenchBlueShade1" as const,
          description: {
            primary: "Learn to read with imaginative stories",
            subtext:
              "Readers will develop phonics and sight reading skills as they advance from picture books into richer narratives.",
          },
          primaryHeading: "Preschool – 2nd Grade",
          ribbonProps: {
            bgColor: "frenchBlueShade1" as const,
            label: "Ages 4 - 8",
            labelColor: "white" as const,
          },
        },
        imageProps: {
          alt: "Stack of books for children preschool to second grade",
          height: 1000,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/4Y4j7BioOmOjABqjTDGlU7/2dde8fe2175687d5d85d2553e770709d/Homepage_Kids_Focus_Category_Preschool_2nd_grade.png",
          targetHeight: 500,
          width: 1100,
        },
      },
      {
        ctaLabel: "Get 3rd – 5th Grade Box",
        infoCTAProps: {
          borderColor: "mintShade1" as const,
          description: {
            primary: "Take off into solo reading",
            subtext:
              "They’ll build comprehension of wordplay, metaphor, and plot dialogue as vocabulary and genre variety expand.",
          },
          primaryHeading: "3rd – 5th Grade",
          ribbonProps: {
            bgColor: "mintShade1" as const,
            label: "Ages 8 - 11",
            labelColor: "white" as const,
          },
        },
        imageProps: {
          alt: "Stack of books for children third to fifth grade",
          height: 1000,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/1Alu4xNBoVW1wWVfUoccUF/ef7600dc89f6ab6b086702982002ccec/Homepage_Kids_Focus_Category_3rd_5th_grade.png",
          targetHeight: 500,
          width: 1100,
        },
      },
      {
        ctaLabel: "Get 6th – 8th Grade Box",
        infoCTAProps: {
          borderColor: "palmGreen" as const,
          description: {
            primary: "Fortify their lifelong love of learning",
            subtext:
              "Your bookworm will discover topics that spark wonder, and strengthen critical thinking through compelling fiction.",
          },
          primaryHeading: "6th – 8th Grade",
          ribbonProps: {
            bgColor: "palmGreen" as const,
            label: "Ages 11 - 14",
            labelColor: "white" as const,
          },
        },
        imageProps: {
          alt: "Stack of books for children sixth to eigth grade",
          height: 1000,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/5FHlMwyCIQCUGh1ZHARD5T/805f96a2ea5d0cb80b005d60f1c1c90b/Homepage_Kids_Focus_Category_6th_8th_grade.png",
          targetHeight: 500,
          width: 1100,
        },
      },
    ],
  },
  pressLogos: {
    gradient: {
      topColor: "papierBlanc" as const,
      bottomColor: "mintTint3" as const,
    },
  },
  testimonials: {
    bgColor: "mintTint3" as const,
    primaryHeading: (
      <>
        Real families.&nbsp;
        <br />
        Real progress.
      </>
    ),
  },
  explore: {
    bgColor: "papierBlanc" as const,
    eyebrow: "Stories for Every reader",
    primaryHeading: "Explore more of Literati.",
    items: [
      {
        bgColorBottom: "pulpWhite" as const,
        imageProps: {
          alt: "Literati book fairs display",
          height: 550,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/7fm8Ivwrzy7xfGPrLHKafg/14625ee3ab90d729186a710d2cf0b7e4/Homepage_Kids_Focus_Explore_Book_Fairs.jpg",
          width: 728,
        },
        location: "https://www.literati.com/bookfairs",
        primaryCopy: "School Book Fairs",
        subtext: (
          <>
            The easiest book fair you’ll ever set up.
            <br />
            <br />
            <strong>
              <u>Learn More</u>
            </strong>
          </>
        ),
      },
      {
        bgColorBottom: "pulpWhite" as const,
        imageProps: {
          alt: "Girl smiling and reading a book",
          height: 550,
          src: "//images.ctfassets.net/vqtz4cq2w5ts/4lXzaeu0TAnzxgpnuvUgZU/dc9103b06382c8bcf3097505958a20f1/Homepage_Kids_Focus_Explore_Kids.jpg",
          width: 728,
        },
        location: LANDING_CTA_LINK,
        primaryCopy: "Book Clubs for Kids",
        subtext: (
          <>
            Raise a reader with personalized picks.
            <br />
            <br />
            <strong>
              <u>Get Started</u>
            </strong>
          </>
        ),
      },
    ],
  },
  footerImage: {
    alt: "Books stacked and arranged in a rainbow pattern",
    height: 288,
    src: "//images.ctfassets.net/vqtz4cq2w5ts/LoZ08V9w3G7BG8OhvYu3h/3bd7aa991344fec53f6accc3880ad767/Homepage_Kids_Focus_Overhead_Rainbow_Books.png",
    width: 1440,
  },
};

export const prepaidLandingConfig = {
  ...landingConfig,
  howItWorks: {
    gradient: {
      topColor: "frenchBlueTint4" as const,
      bottomColor: "papierBlanc" as const,
    },
    eyebrow: "HOW OUR BOOK CLUBS WORK",
    heading:
      "3 Personalized books in every box. Delivered straight to your door.",
    items: [
      {
        imageProps: {
          alt: "illustration of kids of various ages with books in front of them",
          height: 230,
          src: "https://siren-images.literati.com/images/kids_books_confetti_illustration_transparent.original.png",
          width: 230,
        },
        primaryCopy: "Personalized Picks",
        subtext:
          "Our experts send books that match each reader’s level and interests.",
      },
      {
        imageProps: {
          alt: "illustration of child placing box into mailbox",
          height: 230,
          src: "https://siren-images.literati.com/images/calendar_mailbox_illustration_transparent.original.png",
          width: 230,
        },
        primaryCopy: "Flexible & Convenient",
        subtext: "Adjust your delivery schedule so that it’s just right.",
      },
      {
        imageProps: {
          alt: "illustration of books and confetti exploding out of a literati box",
          height: 230,
          src: "https://siren-images.literati.com/images/book_box_confetti_illustration_transparent.original.png",
          width: 230,
        },
        primaryCopy: "Better with Every Box",
        subtext:
          "Rate your deliveries so that your reader keeps getting better books.",
      },
    ],
  },
};

export type LandingConfigType = typeof landingConfig;

export default landingConfig;
